import { render, staticRenderFns } from "./WizardView.vue?vue&type=template&id=87b1ef38&"
import script from "./WizardView.vue?vue&type=script&lang=js&"
export * from "./WizardView.vue?vue&type=script&lang=js&"
import style0 from "./WizardView.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VContainer,
  VIcon,
})
